<template>
  <div class="signup">
    <div v-if="!isEdit" class="mb-4">
      <VkBtn class="mb-4" @click="loginVk">
        Зарегестрироваться через ВКонтакте
      </VkBtn>
      <AuthDelimiter />
    </div>
    <form class="signup__form" @submit.prevent="submit">
      <div class="signup__fields">
        <div class="signup__row row">
          <div class="col-sm-6">
            <AppControl
              label="Имя"
              class="signup__control"
              :error="getError('first_name')"
            >
              <AppInput
                v-model="$v.form.first_name.$model"
                class="signup__input"
                :invalid="isInvalid('first_name')"
                placeholder="Введите имя"
                theme="third"
                @input="clearError('first_name')"
              />
            </AppControl>
          </div>

          <div class="col-sm-6">
            <AppControl
              label="Фамилия"
              class="signup__control"
              :error="getError('last_name')"
            >
              <AppInput
                v-model="$v.form.last_name.$model"
                class="signup__input"
                :invalid="isInvalid('last_name')"
                placeholder="Введите фамилию"
                theme="third"
                @input="clearError('last_name')"
              />
            </AppControl>
          </div>

          <div class="col-sm-6">
            <AppControl
              label="Отчество"
              class="signup__control"
              :error="getError('middle_name')"
            >
              <AppInput
                v-model="$v.form.middle_name.$model"
                class="signup__input"
                :invalid="isInvalid('middle_name')"
                placeholder="Введите отчество"
                theme="third"
                @input="clearError('middle_name')"
              />
            </AppControl>
          </div>

          <div class="col-md-6">
            <AppControl
              label="Дата рождения"
              class="signup__control"
              :error="getError('birthday')"
            >
              <AppDatePicker
                v-model="$v.form.birthday.$model"
                :invalid="isInvalid('birthday')"
                class="signup__input"
                placeholder="Выберите дату"
                theme="third"
                format="YYYY-MM-DD"
                :max-date="maxDate"
                @input="clearError('birthday')"
              />
            </AppControl>
          </div>

          <div class="col-sm-6">
            <AppControl
              label="E-mail"
              class="signup__control"
              :error="getError('email')"
            >
              <AppInput
                v-model="$v.form.email.$model"
                class="signup__input"
                :invalid="isInvalid('email')"
                :disabled="needDisableEmail"
                placeholder="Введите E-mail"
                theme="third"
                type="email"
                @input="clearError('email')"
              />
            </AppControl>
          </div>

          <div class="col-sm-6">
            <AppControl
              label="Телефон"
              class="signup__control"
              :error="getError('mobile_number')"
            >
              <AppInput
                v-mask="'+7##########'"
                v-model="$v.form.mobile_number.$model"
                class="signup__input"
                :invalid="isInvalid('mobile_number')"
                placeholder="Введите телефон"
                theme="third"
                @input="clearError('mobile_number')"
              />
            </AppControl>
          </div>

          <template v-if="!isEdit">
            <div class="col-sm-6">
              <AppControl
                label="Пароль"
                class="signup__control"
                :error="getError('password')"
              >
                <AppInput
                  v-model="$v.form.password.$model"
                  class="signup__input"
                  :invalid="isInvalid('password')"
                  placeholder="Введите пароль"
                  theme="third"
                  type="password"
                />
              </AppControl>
            </div>

            <div class="col-sm-6">
              <AppControl
                label="Повторите пароль"
                class="signup__control"
                :error="getError('repeatPassword')"
              >
                <AppInput
                  v-model="$v.form.repeatPassword.$model"
                  class="signup__input"
                  :invalid="isInvalid('repeatPassword')"
                  placeholder="Повторите пароль"
                  theme="third"
                  type="password"
                />
              </AppControl>
            </div>
          </template>
        </div>
      </div>

      <div
        class="signup__agreement"
        :class="{ 'is-invalid': isInvalid('rules_agreement') }"
      >
        <AppCheckboxLabel>
          <AppCheckbox v-model="$v.form.rules_agreement.$model" />
          С правилами турнира по ссылке
          <a
            class="app-link"
            href="https://shlemkragi.redbull.com/uploads/%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BE%D1%82%D0%B1%D0%BE%D1%80%D0%BE%D1%87%D0%BD%D1%8B%D1%85_%D1%81%D0%BE%D1%80%D0%B5%D0%B2%D0%BD%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B8%CC%86.pdf"
            target="_blank"
            >redbull.ru/SiKrules</a
          >
          ознакомлен.
        </AppCheckboxLabel>
      </div>

      <div
        class="signup__agreement"
        :class="{ 'is-invalid': isInvalid('personal_agreement') }"
      >
        <AppCheckboxLabel>
          <AppCheckbox v-model="$v.form.personal_agreement.$model" />
          Настоящим я подтверждаю, что персональные данные, предоставляемые мной
          при регистрации, включают в себя фамилию, имя, дату рождения,
          контактный телефон, адрес электронной почты, прямо или косвенно
          относящиеся к моей личности, являются правдивыми и достоверными (далее
          - «Персональные данные»). Нажимая на кнопку "ОТПРАВИТЬ" ниже, я
          выражаю свое согласие на добровольное предоставление и дальнейшую
          обработку своих Персональных данных ООО "Ред Булл (Рус)". Настоящее
          согласие дается мной ООО "Ред Булл (Рус)" на обработку моих
          Персональных данных для целей участия в маркетинговом мероприятии под
          условным наименованием: RED BULL ШЛЕМ И КРАГИ. Настоящим я даю свое
          согласие на осуществление любых действий в отношении моих Персональных
          данных, которые необходимы или желаемые для достижения указанных выше
          целей, включая, без ограничения: сбор, систематизацию, накопление,
          хранение, уточнение (обновление, изменение), использование,
          распространение (в том числе передача), обезличивание, блокирование,
          уничтожение, трансграничную передачу Персональных данных, а также
          осуществление любых иных действий с моими Персональными данными в
          рамках действующего законодательства РФ. Обработка персональных данных
          осуществляется ООО "Ред Булл (Рус)" с применением следующих основных
          способов: сбор, хранение, запись на электронные носители и их
          хранение, составление перечней, маркировка с использованием серверов,
          расположенных на территории Российской Федерации с возможностью
          трансграничной передачи и хранения на серверах, расположенных за
          пределами территории Российской Федерации. Настоящее согласие дается
          мной при условии, что ООО "Ред Булл (Рус)", включая его сотрудников,
          обязуется соблюдать конфиденциальность полученных персональных данных
          и предпринять все возможные меры для обеспечения защиты моих
          Персональных данных, а также при условии, что мои Персональные данные
          не будут переданы третьим лицам, кроме лиц, входящих в группу компаний
          Red Bull и за исключением случаев, когда такое предоставление является
          обязательным в силу закона. Настоящее согласие дается мной до
          истечения сроков хранения соответствующей информации, определяемых в
          соответствии с законодательством РФ. Отзыв настоящего согласия может
          быть произведен в письменной форме путем направления соответствующего
          письменного уведомления в адрес ООО "Ред Булл (Рус)" не менее чем за 3
          (три) дня до момента отзыва согласия.
        </AppCheckboxLabel>
      </div>

      <div
        class="signup__agreement"
        :class="{ 'is-invalid': isInvalid('policy_agreement') }"
      >
        <AppCheckboxLabel>
          <AppCheckbox v-model="$v.form.policy_agreement.$model" />
          Я прочитал и ознакомился с
          <a
            class="app-link"
            href="https://policies.redbull.com/policies/Red_Bull_Global/201910211049/ru/privacy.html"
            target="_blank"
            >Политикой конфиденциальности.</a
          >
        </AppCheckboxLabel>
      </div>

      <AppBtn
        type="submit"
        class="signup__submit"
        color="third"
        :loading="loading"
      >
        {{ isEdit ? "Сохранить" : "Регистрация" }}
      </AppBtn>

      <AppBtn
        v-if="isEdit"
        type="button"
        class="signup__submit mt-2"
        color="third"
        @click="logoutAction"
      >
        Выход
      </AppBtn>

      <template v-if="showSignin">
        <div class="signin__message mt-3">Уже есть аккаунт?</div>

        <AppBtn
          type="button"
          class="signin__btn"
          color="third"
          @click="$emit('to-signin')"
        >
          Авторизоваться
        </AppBtn>
      </template>
    </form>
  </div>
</template>

<script>
import AppControl from "@/components/ui/control/AppControl.vue";
import { getValidationMessage } from "@utils/validation-messages";
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import { requestAlert, showAlert } from "@/core/common/";
import { asyncModal } from "@/components/ui/modal/";
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import pick from "lodash/pick";
import AuthDelimiter from "./AuthDelimiter";
import VkBtn from "./VkBtn";

const fiveYears = 1000 * 60 * 60 * 24 * 365 * 5;

const defaultForm = () => ({
  first_name: "",
  middle_name: "",
  last_name: "",
  birthday: "",
  email: "",
  mobile_number: "",
  password: "",
  repeatPassword: "",
  rules_agreement: false,
  personal_agreement: false,
  policy_agreement: false
});

const Signup = {
  name: "Signup",

  props: {
    showSignin: Boolean,
    profile: {
      type: Object
    }
  },

  directives: { mask },

  components: {
    VkBtn,
    AppControl,
    AuthDelimiter
  },

  data: () => ({
    form: defaultForm(),
    formErrors: {},
    loading: false,
    maxDate: Date.now() - fiveYears,
    needDisableEmail: false
  }),

  computed: {
    isEdit() {
      return !!this.profile;
    },
    action() {
      return this.isEdit ? this.updateProfile : this.signup;
    },
    hasEmail() {
      return this.profile && this.profile.email;
    }
  },

  validations() {
    const mainForm = {
      first_name: { required },
      middle_name: { required },
      last_name: { required },
      birthday: { required },
      email: { required, email },
      mobile_number: { required },
      rules_agreement: { sameAs: sameAs(() => true) },
      personal_agreement: { sameAs: sameAs(() => true) },
      policy_agreement: { sameAs: sameAs(() => true) }
    };

    const additionalForm = {
      password: { required, minLength: minLength(6) },
      repeatPassword: { sameAs: sameAs("password") }
    };

    if (!this.isEdit) Object.assign(mainForm, additionalForm);

    return { form: mainForm };
  },

  async created() {
    if (this.isEdit) this.pickData();
    this.needDisableEmail = this.isEdit && this.profile.email;
  },

  methods: {
    ...mapActions("auth", ["signup", "updateProfile", "login", "logout"]),

    logoutAction() {
      this.logout();
      this.$modals.close(this);
    },

    pickData() {
      const data = pick(this.profile, [
        "first_name",
        "middle_name",
        "last_name",
        "birthday",
        "mobile_number",
        "email"
      ]);
      Object.assign(this.form, data);
    },

    clearError(field) {
      delete this.formErrors[field];
    },

    async loginVk() {
      try {
        const { success } = await this.login({ method: "vk" });
        if (success) this.$modals.close(this);
      } catch (e) {
        requestAlert();
        console.log(e);
      }
    },

    getError(field) {
      return (
        getValidationMessage(this.$v.form[field]) ||
        (this.formErrors[field] && this.formErrors[field][0])
      );
    },

    isInvalid(field) {
      return this.$v.form[field].$error || !!this.formErrors[field];
    },

    async submit() {
      if (this.loading) return;
      this.formErrors = {};
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      try {
        const { success, data } = await this.action(this.form);
        if (success) {
          this.form = defaultForm();
          this.$modals.close(this);
          showAlert("Вы успешно зарегистрировались на сайте!");
        } else {
          this.formErrors = data || {};
        }
      } catch (e) {
        requestAlert();
        console.log(e);
      }
      this.loading = false;
    }
  }
};

export default Signup;

export function openModal(profile) {
  return asyncModal({
    name: "signup-modal",
    component: Signup,
    title: profile ? "Необходимая информация" : "Регистрация пользователя",
    dismissable: false,
    closable: !profile,
    props: {
      profile
    }
  });
}
</script>

<style lang="scss">
.signup {
  width: 550px;
  max-width: 100%;
  margin: 0 auto;

  &__fields {
    max-width: 100%;
    margin: 0 auto;

    @include breakpoint("xs-only") {
      width: 100%;
    }
  }

  &__control {
    margin-bottom: 25px;
  }

  &__submit {
    width: 265px;
    height: 55px;
    text-transform: uppercase;
    margin: 0 auto;
    display: flex;
    font-size: 24px;
  }

  &__input,
  &__input .app-input {
    text-transform: uppercase;
    font-size: 20px;
    height: 60px;
    font-weight: bold;
  }

  &__agreement {
    font-size: 16px;
    display: flex;
    margin: 20px 0 30px;
    color: colors(text-2);

    &.is-invalid {
      color: colors(warning);
    }
  }
}
</style>
